// Contesto di navigazione tra elenco e dettaglio dei progetti (per scheda del browser):
// l'ordine dell'elenco filtrato (frecce precedente/successivo) e i filtri a cui tornare.
const NAV_KEY = 'runtime.projectsNav';

export function saveProjectsNav(nav) {
  try {
    sessionStorage.setItem(NAV_KEY, JSON.stringify(nav));
  } catch (e) {
    // sessionStorage non disponibile: le frecce useranno l'ordine alfabetico
  }
}

/** { ids: string[], search: string } oppure null. */
export function readProjectsNav() {
  try {
    const nav = JSON.parse(sessionStorage.getItem(NAV_KEY) || 'null');
    return nav && Array.isArray(nav.ids) ? nav : null;
  } catch (e) {
    return null;
  }
}

/** Percorso base: le pagine restano su /projects-v2 se aperte da lì. */
export const projectsBase = (pathname) => (pathname.startsWith('/projects-v2') ? '/projects-v2' : '/projects');
